var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.196 160H48.8047C47.5613 160 46.3691 159.506 45.4903 158.627L1.37313 114.51C0.49375 113.631 0 112.439 0 111.196V48.8044C0 47.5612 0.49375 46.3691 1.37313 45.49L45.49 1.37313C46.3691 0.49375 47.5613 0 48.8047 0H111.196C112.439 0 113.631 0.494063 114.51 1.37313L158.627 45.49C159.506 46.3691 160 47.5612 160 48.8044V111.195C160 112.438 159.506 113.631 158.627 114.51L114.51 158.627C113.631 159.506 112.439 160 111.196 160Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94.0625C72.2459 94.0625 65.9375 87.7541 65.9375 80V42.5C65.9375 34.7459 72.2459 28.4375 80 28.4375C87.7541 28.4375 94.0625 34.7459 94.0625 42.5V80C94.0625 87.7541 87.7541 94.0625 80 94.0625Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 131.562C72.2459 131.562 65.9375 125.254 65.9375 117.5C65.9375 109.746 72.2459 103.438 80 103.438C87.7541 103.438 94.0625 109.746 94.0625 117.5C94.0625 125.254 87.7541 131.562 80 131.562Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 80,
    y1: 160,
    x2: 80,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 80,
    y1: 94.0625,
    x2: 80,
    y2: 28.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 80,
    y1: 131.562,
    x2: 80,
    y2: 103.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoWarning);
export default __webpack_public_path__ + "static/media/picto_warning.e7805e8f2949dcf4269614f3bfc043f5.svg";
export { ForwardRef as ReactComponent };